"use client";

import { c as _c } from "react/compiler-runtime";
import { Facepile } from "@opensea/next-ui-kit";
import { Flex } from "@opensea/ui-kit";
import { useShallow } from "zustand/react/shallow";
import { useProfileTokensSelectionStore } from "../ProfileTokensSelectionProvider";
export function ProfileTokensSelectionPreview() {
  const $ = _c(7);
  const selectedTokensMap = useProfileTokensSelectionStore(useShallow(_temp));
  let t0;
  if ($[0] !== selectedTokensMap) {
    t0 = Array.from(selectedTokensMap.values());
    $[0] = selectedTokensMap;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const selectedTokens = t0;
  let t1;
  if ($[2] !== selectedTokens) {
    t1 = selectedTokens.map(_temp2);
    $[2] = selectedTokens;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      Avatar: {
        className: "rounded-full"
      }
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1) {
    t3 = <Flex className="shrink-0 gap-3"><Facepile avatars={t1} overrides={t2} size={32} /></Flex>;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function _temp2(token) {
  return {
    src: token.currency?.metadata?.fullCollection?.imageUrl || token.currency?.imageUrl || ""
  };
}
function _temp(v) {
  return v.selectedTokensMap;
}